import React, { Component } from 'react';
import { hideModal, MODAL_QUESTION_MULTY_CATEGORY_DELETE } from '../../../../../../modules/modals';
import { connect } from 'react-redux'
import Modal from 'react-modal';
import PropTypes from 'prop-types'
import {toastr} from 'react-redux-toastr'
import { deleteQuestionCategory } from '../../../../actions';

class DeleteModal extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  handleClose = () => {
    const { hideModal } = this.props;
    hideModal({ modalType : MODAL_QUESTION_MULTY_CATEGORY_DELETE});

  }

  getTitle = () => {
    const {formatMessage} = this.context
    let text = "frmTitleDeleteQuestionCategory"
    return <div className="create-dialog-modal-content__title">{formatMessage(text)}</div>;
  }

  delete = async(e) => {
    e.preventDefault();
    try {
      const {formatMessage} = this.context;
      const { category_id, deleteQuestionCategory} = this.props;
      await deleteQuestionCategory(category_id);
      this.handleClose();
      toastr.success(formatMessage('msgNotificationQuestionCategory'), formatMessage('msgNotificationQuestionCategoryDeleted'))
    } catch (error) {
      
    }
  }

  render() {
    const {formatMessage} = this.context
    const { zIndex} = this.props;
    return (
      <Modal
          isOpen = {true}
          style = {{
              overlay : {zIndex},
          }}
          onRequestClose={this.handleClose}
          overlayClassName = "custom-modal"
          className = "custom-modal-content create-dialog-modal-content"
      >
          <div className="create-dialog-modal-content__header">
              {
                this.getTitle()
              }
              <div
                  onClick={this.handleClose}
                  className="create-dialog-modal-content__close"
              ></div>
          </div>
          <div className="create-dialog-modal-content__body">
            <form className="create-dialog-form" onSubmit={this.delete}>
              <div className="row mb-5">
                <div className="col-xs-12 text-center text-danger word-wrap-break">{formatMessage('frmMessageDeleteQuestionCategory')}</div>
              </div>
              <div className="create-dialog-form__group flex">
                <button className="btn btn-primary mr-auto" type="submit">{formatMessage('btnModalDelete')}</button>
                <button className="btn btn-warning" type="button" onClick={() => {
                  this.handleClose();
                }}>{formatMessage('btnModalCancel')}</button>
              </div>
            </form>
          </div>
      </Modal>
    );
  }
}



const mapStateToProps = (state, ownProps) => ({
})

const mapDispatchToProps = {
  hideModal,
  deleteQuestionCategory,
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteModal)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Question/components/Category/components/DeleteModal/index.jsx